import styled from "styled-components";

export const StyledVideo = styled.video`
  height: auto;
  width: 100%;
`;
